export default __webpack_public_path__ + "static/media/11.ba4f7596.png";